import request from '@/utils/request'

export function GetOrderUniqueId (data) {
  return request({
    url: '/api/orderQuery/GetOrderUniqueId',
    method: 'post',
    data
  })
}